export default "__VITE_ASSET__jsRh5fJt__"